import { Link } from 'react-router-dom';

const LoadPassLogo = ({ to }: { to: string }) =>
  <Link className="d-flex align-items-center" to={to} aria-label="LP_Logo">
    <img src="/images/lp_logo.png" alt="LOADPASS" style={{ width: 'var(--brand-width)' }} />
  </Link>;

export { LoadPassLogo };
